import { Entity, Field } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration';
import { DateTime } from 'luxon';
// import * as mysql from 'mysql2';

@Entity()
export class Feedback extends MongoEntity {
  static _class = 'Feedback';
  static _collectionName = 'feedback';
  static get allFields() {
    return selectionSet(() => Feedback, 1);
  }

  @Field(type => String) public course!: string;
  @Field(type => DateTime) public timestamp!: DateTime;
  @Field(type => String) public recipients!: [];
  //@Field(type => String) public entry!: string;
  @Field(type => String) public intervalStart!: string;
  @Field(type => String) public intervalEnd!: string;
  @Field(type => String) public posFb!: string;
  @Field(type => String) public negFb!: string;
  @Field(type => String) public recFb!: string;
  @Field(type => String) public elseFb!: string;
  @Field(type => String) public url!: string;
  @Field(type => String) public goal!: string | undefined;
  @Field(type => String) public task!: string | undefined;
  @Field(type => String) public automate!: boolean;
  @Field(type => String) public mode!: 'goal' | 'task' | 'perc' | 'percgoal' | null;
  // @Field(type => String) public userId!: string;
  // @Field(type => String) public userName!: string;
  // @Field(type => String) public pseudoRealname!: string;

  @Field(type => String) public objective!: 'goal' | 'task';
  @Field(type => String) public singleObjectiveId!: string | null; // If set to to null, then feedback applies to all objectives!
  @Field(type => String) public type!: 'pos' | 'neg' | 'rec' | 'else';
}
